<template>

  <div class="uk-animation-fade" ref="container">

    <div class=""
         v-if="likeApiResponse && likeApiResponse['success']"
         v-html="labels['likeSubmitThankYouBody']"
    >
    </div>

    <form :class="{'uk-hidden':likeApiResponse}" class="uk-form-stacked" @submit="onSubmit" novalidate autocomplete="off">

      <div v-if="isBusinessHours" v-html="labels['likeFormIntroBodyBusinessHours']" class="uk-margin-medium-bottom">
      </div>
      <div v-else v-html="labels['likeFormIntroBodyNonBusinessHours']" class="uk-margin-medium-bottom">
      </div>

      <hr style="border-top-width: 1px;" class="uk-margin-medium"/>

      <div class="uk-grid uk-child-width-1-2@m">
        <div>
          <kmc-input-text class="kmc-form-control uk-display-block" :name="'firstName'" :label="'First name:'" :required="true"></kmc-input-text>
        </div>
        <div>
          <kmc-input-text class="kmc-form-control uk-display-block" :name="'lastName'" :label="'Surname:'" :required="true"></kmc-input-text>
        </div>
      </div>

      <div class="uk-grid uk-child-width-1-2@m">
        <div>
          <kmc-input-text class="kmc-form-control uk-display-block" :name="'phone'" :label="'Phone:'" :required="true"></kmc-input-text>
        </div>
        <div>
          <kmc-input-text class="kmc-form-control uk-display-block" :name="'email'" :label="'Email:'" :required="true"></kmc-input-text>
        </div>
      </div>

      <kmc-input-textarea class="kmc-form-control uk-display-block" :name="'message'" :label="'Your message:'" :rows="3" :required="true"></kmc-input-textarea>
      <div>
        <span>*mandatory field</span>
      </div>

      <kmc-input-checkbox
          class="kmc-form-control uk-display-block uk-width-1-1"
          :name="'consent'"
          label='By ticking this box you consent to us sharing your details with <a href="//www.likemortgageadvice.com" target="_blank" rel="noopener noreferrer">Like Mortgage Advice.</a>'
          helpText='If you’d prefer to find your own mortgage adviser, visit <a href="//www.unbiased.co.uk" target="_blank" rel="noopener noreferrer">Unbiased.co.uk</a> where you’ll find a list of independent mortgage advisers who can review the whole of the market.'
      />

      <div class="uk-alert uk-alert-danger uk-border-rounded" v-if="!isValid && submitCount" v-html="labels['formGenericErrorMessage']"/>

      <div class="uk-alert uk-alert-danger uk-border-rounded" v-if="submitErrorMessage && isValid && submitCount" v-html="submitErrorMessage"></div>

      <div v-if="loading" class="uk-text-center">
        <div uk-spinner="ratio: 2"></div>
      </div>

      <div class="uk-margin-medium uk-text-center">
        <button type="submit" class="uk-button uk-button-primary uk-width-1-2@m" v-html="'Request a callback'"/>
      </div>
    </form>

  </div>

</template>

<script>

import {onMounted, ref} from "vue";
import {KmcInputCheckbox, KmcInputText, KmcInputTextarea} from "./index";
import {useForm, useIsFormValid} from "vee-validate";
import * as Yup from "yup";
import {phone} from "../validations";
import {getReCaptchaToken} from "../util";
import {isLikeBusinessHours} from "../util/like";

export default {
  name: "KmcContactLike",
  components: {KmcInputTextarea},
  emits: ['recalculate'],
  props: {
    labels: {
      type: Object
    },
    data: {
      type: Object,
    },
  },
  beforeCreate() {
    this.$options.components.KmcInputText = KmcInputText
    this.$options.components.KmcInputTextarea = KmcInputTextarea
    this.$options.components.KmcInputCheckbox = KmcInputCheckbox
  },
  setup: function (props, context) {

    const container = ref(null)
    const schema = ref({})

    const {handleSubmit, submitCount, resetForm, setValues} = useForm({validationSchema: schema})

    const loading = ref(false)
    const submitErrorMessage = ref()
    const isValid = useIsFormValid()

    const likeApiResponse = ref()

    onMounted(() => {
      schema.value = Yup.object({
        firstName: Yup.string().required(),
        lastName: Yup.string().required(),
        email: Yup.string().email().required(),
        phone: phone().required(),
        consent: Yup.boolean().oneOf([true], "This is mandatory field").required()
      })

      // setValues({
      //   firstName: 'John',
      //   lastName: 'Doe',
      //   email: 'john@doe.example',
      //   phone: '0123467890',
      //   message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vehicula ipsum non elit rutrum fringilla. Aenean leo magna, convallis eu dolor gravida, rutrum mattis lorem.',
      //   consent: true
      // })
      // likeApiResponse.value = {success: true}

    })

    const calculationResult = props.data
    const labels = props.labels

    const onSubmit = handleSubmit(async (values) => {
      if (loading.value) return;

      try {
        loading.value = true
        submitErrorMessage.value = ''

        const token = await getReCaptchaToken();
        const captcha = new URLSearchParams({token})

        let requestData = prepareLikeRequestData(calculationResult, values)

        const response = await fetch(`${location.pathname}/RequestLikeCallback?${captcha}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });

        if (!response.ok) {
          // noinspection ExceptionCaughtLocallyJS
          throw response.statusText + response.status
        }

        const data = await response.json()

        if (data['success'] && data['success'] === true) {
          likeApiResponse.value = data
          resetForm({values: {}})
        } else {
          // noinspection ExceptionCaughtLocallyJS
          throw data
        }

      } catch (e) {

        submitErrorMessage.value = labels['likeSubmitErrorMessage']; //'<p class="">We\'re really sorry, we\'re experiencing a few technical difficulties. <br/>Please try again, or you can contact Like Mortgage Advice directly on <a href="tel:02038278940">0203 827 8940</a> (Mon-Fri, 9am – 5.30pm)</p>'
        console.error('API Error', e);
      } finally {
        loading.value = false
      }
    })

    const formatAgeGroup = (age) => {
      age = parseInt(age)
      return age < 51 ? `${age}-${age + 9}` : '51 and over'
    }

    const prepareLikeRequestData = function (calcResult, contactDetails) {
      const calcRequest = calcResult.request

      const applicantsCount = calcRequest.applicant.length

      let data = {

        applicationIdentifier: calcRequest.application_identifier,

        contactDetails: contactDetails,

        affordabilityResult: calcResult.calculator_output.maximum_balance,
        applicationAssessableIncome: calcResult.calculator_output.application_assessable_income,

        loanAmount: calcRequest.loan_amount,
        loanType: calcRequest.loan_type.toLowerCase(),
        loanPurpose: calcRequest.loan_purpose.toLowerCase(),
        loanTermYears: calcRequest.loan_term_requested / 12,

        propertyValuation: calcRequest.property_valuation,
        propertyRegion: calcRequest.property_region,

        stage: calcRequest.stage,

        applicantsCount: applicantsCount,
        applicant1Income: calcRequest.applicant[0]['salary'],
        applicant2Income: applicantsCount > 1 ? calcRequest.applicant[1]['salary'] : 0,

        applicantAgeGroup: formatAgeGroup(calcRequest.ageGroup),

        applicantPostcode: calcRequest.applicant[0]['post_code'],
      }

      if (data.loanType === 'residential') {
        data['residential'] = {
          isFirstTimeBuyer: calcRequest.applicant[0].ftb,
          propertyUse: calcRequest.propertyUse,
          deposit: calcRequest.deposit,
          fixedRateYears: calcRequest.product_initial_rate_period / 12,
          creditExpenditure: calcRequest.credit_expenditure,
          occupation: calcRequest.job_title,
          dependentsOver17: calcRequest.dependentsOver17,
          dependentsUnder16: calcRequest.dependentsUnder16,
        }

        if (data['residential']['fixedRateYears'] > 40) {
          data['residential']['fixedRateYears'] = 'Fixed for term'
        }
      }

      if (data.loanType === 'btl') {
        const hmo = calcRequest.propertyIsHouseInMultipleOccupation
        const mub = calcRequest.propertyIsMultiUnitBlock

        data['buyToLet'] = {
          loanSubtype: calcRequest.loan_subtype, // "Individual" or "LimitedCompany",
          existingPortfolio: !!calcRequest['number_btl_properties'],
          monthlyRentalIncome: calcRequest['property_rental_income'],
          propertyIsHouseInMultipleOccupation: hmo,
          propertyIsMultiUnitBlock: mub,
        }

        if (data['buyToLet']['existingPortfolio']) {
          data['buyToLet']['portfolio'] = {
            propertiesCount: calcRequest['number_btl_properties'],
            mortgagedPropertiesCount: calcRequest['number_btl_mortgaged_properties'],
            monthlyCombinedRentalIncome: calcRequest['total_btl_monthly_rental_income'],
            totalEstimatedPropertiesValue: calcRequest['total_btl_property_value'],
            totalOutstandingMortgagesAmount: calcRequest['outstanding_btl_mortgage_balance'],
          }
        }

      }

      return data
    }

    const isBusinessHours = isLikeBusinessHours();

    return {
      onSubmit,
      container,
      loading,
      submitErrorMessage,
      isValid,
      submitCount,
      likeApiResponse,
      isBusinessHours
    }
  }
}

</script>

